module.exports = __webpack_public_path__ + "static/12-dde2bb573cbe02607ad52a8ad68b551d.jpg";